import { Dispatch } from "redux";
import request from "../../util/request";
import actions from "../../util/actions";
import errorHandler from "../../util/error-handler";

export const getBlogs = (search: string, page: number, per_page: number) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.BLOGS_HTTP_LOADING
    });

    request({
      method: "get",
      pathname: "getBlogs",
      params: { search, page, per_page }
    })
      .then((response) => {
        dispatch({
          type: actions.BLOGS_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });

        dispatch({
          type: actions.SET_BLOGS_DETAILS,
          payload: {
            ...response.data.content
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.BLOGS_HTTP_ERROR, error, dispatch);
      });
  };
};
